'use client';

const RELOAD_FLAG = 'chunk-error-reload-attempted';

/**
 * A ChunkLoadError means the browser failed to fetch a JS chunk — most often
 * a stale HTML shell referencing chunk hashes from a previous deployment, or
 * a dropped request on a flaky network. A hard reload fetches fresh HTML with
 * current hashes, so it is the correct recovery. Reload at most once per
 * browser session to avoid an infinite reload loop when the chunk URL is
 * permanently broken (e.g. CDN edge 404).
 *
 * Returns true if a reload was triggered (caller should render nothing else).
 */
export function reloadOnceOnChunkError(error: Error): boolean {
    if (typeof window === 'undefined') return false;
    const isChunkError =
        error.name === 'ChunkLoadError' ||
        /loading chunk|failed to fetch dynamically imported module|dynamically imported module/i.test(
            error.message ?? '',
        );
    if (!isChunkError) return false;
    try {
        if (sessionStorage.getItem(RELOAD_FLAG)) return false;
        sessionStorage.setItem(RELOAD_FLAG, '1');
    } catch {
        // sessionStorage unavailable (private mode) — still allow one reload;
        // a permanent failure ends at the error UI anyway after this attempt.
    }
    window.location.reload();
    return true;
}
